import { render, staticRenderFns } from "./data_screen2.vue?vue&type=template&id=5da5bf6e&scoped=true&"
import script from "./data_screen2.vue?vue&type=script&lang=js&"
export * from "./data_screen2.vue?vue&type=script&lang=js&"
import style0 from "./data_screen2.vue?vue&type=style&index=0&id=5da5bf6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5bf6e",
  null
  
)

export default component.exports